/**
 * A collection of CSS colours we want to work with.
 */
export const COLOUR_SET = {
	gray: "rgba(105, 105, 105, 1)",
	maroon: "rgba(85, 17, 17, 1)",
	red: "rgba(170, 85, 85, 1)",
	paleGreen: "rgba(142,174,79, 1)",
	paleBlue: "rgba(92, 97, 153, 1)",
	green: "rgba(50, 205, 50, 1)",
	darkGreen: "rgba(30, 130, 76, 1)",
	blue: "rgba(70, 130, 180, 1)",
	gold: "rgba(255, 215, 0, 1)",
	vibrantYellow: "rgba(245, 229, 27, 1)",
	teal: "rgba(127, 255, 212, 1)",
	white: "rgba(192, 192, 192, 1)",
	purple: "rgba(153, 50, 204, 1)",
	vibrantPurple: "rgba(161, 23, 230, 1)",
	paleOrange: "rgba(235, 151, 78, 1)",
	orange: "rgba(248, 148, 6, 1)",
	vibrantOrange: "rgba(248, 175, 6, 1)",
	vibrantBlue: "rgba(43, 149, 237, 1)",
	vibrantGreen: "rgba(26, 232, 26, 1)",
	vibrantRed: "rgba(243, 23, 45, 1)",
	pink: "rgba(255, 182, 193, 1)",
	vibrantPink: "rgba(255, 105, 180, 1)",
};
